window.contentLoaded(window, function (e) {
    var tabsContainer = document.querySelector('.js-table-tabs');
    if(tabsContainer) {
        var tabs = tabsContainer.querySelectorAll('li');
        var table = tabsContainer.parentElement.parentElement.querySelector('table');
        //console.log(table);
    
        tabs.forEach(function(tab, i) {
            tab.addEventListener('click',function(el) {
                
                // remove the existing classes (loop through all in case)
                tabs.forEach(function(t,index) {
                    table.classList.remove('show-col-' + (index+1));
                    t.classList.remove('active');
                });
    
                // add the new class
                table.classList.add('show-col-' + (i+1));
                tabs[i].classList.add('active');
    
            });
        })
    }
});
